import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DashboardPoliza,
  DashboardTransaccion,
} from '../../../interfaces/dashboard.interface';

import { DashboardService } from '../../../services/dashboard.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-principal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './principal.component.html',
  styleUrl: './principal.component.css',
})
export class PrincipalComponent implements OnInit {
  private permissionsService = inject(PermissionsService);
  private readonly dashboardStatsPermission = 'ver:estadisticas-dashboard';

  polizas: DashboardPoliza[] = [];
  movimientos: DashboardTransaccion[] = [];
  url: string = '';

  /**
   * Indica si el usuario logueado puede ver las estadísticas del dashboard.
   */
  canViewDashboardStats = signal<boolean>(false);

  constructor(private dashboardService: DashboardService,private gAnalytics:GoogleAnalyticsService) {}

  ngOnInit() {
    this.loadDashboardData();
    this.loadDashboardStatsPermission();
  }

  /**
   * Consulta los permisos del usuario logueado (con caché) y evalúa si puede ver las estadísticas del dashboard
   */
  private loadDashboardStatsPermission(): void {
    this.permissionsService
      .getLoggedUserPermissions({
        UserExternalId: sessionStorage.getItem('userExternalId') || '',
        ClientId: environment.client_id,
      })
      .subscribe({
        next: (permissions) => {
          this.canViewDashboardStats.set(
            permissions.some(
              (permission) =>
                permission.description === this.dashboardStatsPermission
            )
          );
        },
        error: (error) => {
          console.error('Error al cargar los permisos del dashboard:', error);
          this.canViewDashboardStats.set(false);
        },
      });
  }

  loadDashboardData() {
    this.dashboardService.getDashboardData().subscribe({
      next: (data) => {
        if (data) {
          this.polizas = data.polizas || [];
          this.movimientos = data.movimientos || [];
          this.url = data.url?.url || '';
        } else {
          this.polizas = [];
          this.movimientos = [];
          this.url = '';
        }
      },
      error: (error) => {
        console.error('Error al cargar datos del dashboard:', error);
        this.polizas = [];
        this.movimientos = [];
        this.url = '';
      },
    });
  }


  watchInstructive() {
    this.gAnalytics.trackEvent('inicio_ver_instructivo',{
      page:'/inicio',
      action:'Se hizo click al boton de ver instructivo en el dashboard principal.'
    })
  }

  // Opcional: Método para forzar actualización
  forceRefresh() {
    this.dashboardService.forceRefresh().subscribe({
      next: (data) => {
        this.polizas = data.polizas || [];
        this.movimientos = data.movimientos || [];
        this.url = data.url?.url || '';
      },
      error: (error) => {
        console.error('Error al cargar datos del dashboard:', error);
      },
    });
  }
}
